import React from 'react'
import {urlFor} from '../../utils/sanity/urlFor';

function SkillSection({skillsData}) {
    console.log("Skills", skillsData)
  return (
    <section className="flex flex-col w-full mb-10 xl:mb-40 mt-6 xl:mt-0 border-y border-gray-400">
      <h1 className="heading-font text-2xl md:text-4xl font-bold w-full text-center py-5">
        Core Skills
      </h1>
      <div className="w-full py-5 md:py-7 pt-3 xl:pt-6 flex flex-wrap justify-center">
      { skillsData && skillsData.map((skill) => (
        <div class="px-0 md:px-6 my-6 md:my-6 flex flex-col ">
          
            <div class="pattern-dots-md gray-light">
              <div class="w-60 md:w-80 h-60 md:h-80 p-4 bg-white border border-gray-200 rounded-lg sm:p-8 dark:bg-gray-800 dark:border-gray-700 transform translate-x-6 -translate-y-6 ">
                  <div class="w-5 md:w-10 h-5 md:h-10 inline-flex items-center justify-center rounded-full bg-blue-100 text-blue-500 mb-5 flex-shrink-0">
                  <span dangerouslySetInnerHTML={{ __html: skill.skillIcon }} />
                  </div>
                  
                  <div class="flex-grow">
                      <h6 class="mb-2 text-base md:text-lg font-bold text-gray-900 dark:text-white">{skill.skillTitle}</h6>
                      <div class="leading-relaxed text-sm flex flex-wrap w-full h-full justify-around">
                        { skill.skills.map( (set) => (
                          <span className='p-2 md:p-3'>
                            <img src={urlFor(set.skillIcon)} alt="skill icon" className='w-auto h-6 md:h-8 block m-auto'/>
                            <p className='main-font text-sm mt-1 font-semibold text-center'>{set.skillTitle}</p>
                          </span>

                        ))}
                      </div>
                  </div>
              </div>
            </div>
        
        </div>
        ))}
      </div>
      
    </section>
  )
}

export default SkillSection;